import {makeStyles} from '@material-ui/core'
import CardWithTitle from 'components/atoms/CardWithTitle'
import PageTable from 'pages/Analysis/EEGMCI/PageTable'
import React, {useState} from 'react'
import AIDementiaPredictionStyles from 'pages/Analysis/EEGMCI/style'
import {useHistory, useLocation} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

const useStyles = makeStyles(AIDementiaPredictionStyles)
function EEGMCI() {
  const classes = useStyles()
  const location = useLocation()
  const history = useHistory()
  const [tabActive, setTabActive] = useState(0)
  const {t} = useTranslation()

  const listTabs = [
    {
      id: 0,
      label: t('IDementiaPredictionSteps', {
        step: 5,
      }),
    },
    {
      id: 1,
      label: t('IDementiaPredictionSteps', {
        step: 8,
      }),
    },
  ]
  return (
    <CardWithTitle>
      <div className={`${classes.heathTabs}`}>
        {listTabs.map((item) => (
          <div
            className={`${classes.heathTab} ${
              tabActive === item.id && classes.heathTabActive
            }`}
            onClick={() => {
              setTabActive(item.id)
              history.replace({pathname: location.pathname})
            }}
            aria-hidden='true'
            key={item.id}
          >
            {t(item.label)}
          </div>
        ))}
      </div>
      <PageTable activeTabId={tabActive} />
    </CardWithTitle>
  )
}

export default EEGMCI
